import { useGetTalkroomBadgeCountsQuery } from "../app/services/projectMessages";

/**
 * トークルームのバッジ数（未読数・未ダウンロード数）を BE 集計から取得する。
 *
 * 以前は FE 側でメッセージ最新20件から未読を再計算していたが、取りこぼしや
 * FE/BE の数値乖離があったため、BE のグループ(position)単位集計に一本化した。
 * 未読は完了(resolved)メッセージを除外した件数を返す。
 */
const useTalkroomBadgeCounts = (
  projectId: string | undefined,
  skip = false,
): { unreadCount: number; undownloadCount: number; isLoading: boolean } => {
  const { data, isLoading } = useGetTalkroomBadgeCountsQuery(
    { project_id: projectId || "" },
    { skip: skip || !projectId },
  );

  return {
    unreadCount: data?.data?.unread_message_count ?? 0,
    undownloadCount: data?.data?.undownload_file_count ?? 0,
    isLoading,
  };
};

export default useTalkroomBadgeCounts;
